import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// Vuex store definition
const store = new Vuex.Store({
  state: {
    userType: null
  },
  mutations: {
    updateUserType (state, userType) {
      state.userType = userType
    }
  },
  getters: {
    getUserType: state => {
      return state.userType
    }
  },
  plugins: [createPersistedState()]
})

export default store
